import { TextInput as RNTextInput } from 'react-native';
import { useThemeColors } from './useThemeColors';

export default function AppTextInput(props) {
    const colors = useThemeColors();

    return (
        <RNTextInput
            {...props}
            style={[
                {
                    color: colors.text,
                    // backgroundColor: colors.inputBackground,
                    // padding: 10,
                    //borderRadius: 8,
                },
                props.style,
            ]}
            placeholderTextColor={colors.placeholder}
        />
    );
}
